import { useTranslation } from 'next-i18next'

export default function SessionParticipantInfo({
  email,
  name,
}: {
  email: string | null | undefined
  name: string | null | undefined
}): React.ReactElement {
  const { t } = useTranslation('generics')

  return (
    <span>
      <span className="block">
        <span className="font-medium">{t('name')}</span>: {name}
      </span>
      <span className="block">
        <span className="font-medium">{t('email')}</span>: {email}
      </span>
    </span>
  )
}
